<div class="button-container">
    <mat-button-toggle-group
        name="favoriteColor"
        class="w-100"
        aria-label="Favorite Color"
        [(ngModel)]="selectedOption"
        (ngModelChange)="emit()"
    >
        <mat-button-toggle
            *ngFor="let item of toggleArray"
            [value]="item.name"
            [ngClass]="{ active: item.selected === true }"
            [ngStyle]="{ width: mediumWidth }"
        >
            {{ item.name }}
        </mat-button-toggle>
        <div
            class="slide-button"
            [ngStyle]="{ transform: customElementStyle, width: mediumWidth }"
        ></div>
    </mat-button-toggle-group>
</div>
